<template>
  <div class="wt2-radio-line" :class="{ '-disabled': disabled }">
    <slot name="header"></slot>
    <div class="-radio-line-box">
      <div class="-line"></div>
      <div class="-radio-buttons">
        <div
          class="-button"
          :class="{
            '-disabled': disabled,
            '-active': !disabled && button.value === curValue,
          }"
          v-for="button in buttons"
          :key="button.value"
          @click="updateValue(button.value)"
        >
          <div class="-circle"></div>
          <span>{{ button.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import radioMixin from './mixins/radioMixin.vue';

export default {
  mixins: [radioMixin],
};
</script>
